var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-wrapper",
    {
      attrs: {
        deletable: _vm.event.id != "",
        title: _vm.title,
        "max-width": _vm.maxWidth,
      },
      on: {
        save: function ($event) {
          return _vm.save()
        },
        cancel: function ($event) {
          return _vm.cancel()
        },
        delete: function ($event) {
          return _vm.deleteEvent()
        },
      },
    },
    [
      _c("app-google-calendar-event-edit", {
        attrs: { event: _vm.eventInput },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }